
import moment from 'moment'
import { KabaddiMatch } from './match'

export class ScheduleDay {
  constructor (day, matches) {
    this.day = day
    this.matches = matches
  }
}

export class KabaddiSeasonSchedule {
  constructor (month, isCurrentMonth) {
    this.month = month
    this.isCurrentMonth = isCurrentMonth
    this.days = []
    const lastDay = this.month.clone().endOf('month').date()
    for (let i = 0; i < lastDay; i++) {
      const day = new ScheduleDay(this.month.clone().add(i, 'days'), [], [])
      this.days.push(day)
    }
  }

  static createFromJson (raw) {
    const month = moment(raw.month + '-01', 'YYYY-MM-DD')
    let schedule = new KabaddiSeasonSchedule(month, raw.current_month)
    raw.days.forEach(day => {
      day.matches.forEach(rawMatch => {
        const match = KabaddiMatch.createFromJson(rawMatch)
        if (month.isSame(match.start_at, 'month')) {
          schedule.days[match.start_at.date() - 1].matches.push(match)
        }
      })
    })

    return schedule
  }
}
